import { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { faMinus,faPlus } from '@fortawesome/free-solid-svg-icons';
import { userActivity } from '../../../../common/constants';
import Rate from '../../../../components/Rating';
import { IKImage } from 'imagekitio-react';
import TaskCertificate from '../TaskCertificate';
import './index.css'
const gradeImg = {
  1: 'https://assets.learntube.ai/files/Content_player/Group_5508.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968484801',
  2: 'https://assets.learntube.ai/files/Content_player/Group_5545.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968485587',
  3: 'https://assets.learntube.ai/files/Content_player/Group_5509.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968485311',
  4: 'https://assets.learntube.ai/files/Content_player/Group_5509.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968485311',
  5: 'https://assets.learntube.ai/files/Content_player/Group_5507.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968484567',
};
const getGrade = (score) => {
  if (score <= 10) {
    return { score, grade: 1, img: gradeImg[1], text: 'Poor' };
  } else if (score <= 20) {
    return { score, grade: 2, img: gradeImg[2], text: 'Average' };
  } else if (score <= 30) {
    return { score, grade: 3, img: gradeImg[3], text: 'Good' };
  } else if (score <= 40) {
    return { score, grade: 4, img: gradeImg[4], text: 'Very Good' };
  } else if (score <= 50) {
    return { score, grade: 5, img: gradeImg[5], text: 'Excellent' };
  }
};

export function GradeCard(props) {
  const [showScores, setShowScores] = useState(false);
  const gradeObj = getGrade(props?.score);
  const [showGrade , setShowGrade] = useState(false);
  if(props.type !== 'notupgraded'){
  return (
    <>
      <div className="m-4 flex flex-col items-center justify-between rounded-xl p-4 shadow-2xl">
        <h2 className="py-2 text-xl font-semibold text-[#050505]">
          See how much you scored{' '}
        </h2>
        <h2 className="py-2 text-2xl font-bold text-[#C87902]">
          You scored {gradeObj?.score}
        </h2>
        <div>
          <img src={gradeObj?.img} alt="gradeObj image" srcset="" />
        </div>
        <h2 className="my-2 text-center text-lg font-medium text-[#D4A709]">
          {' '}
          {gradeObj?.text}
        </h2>
        <div className=" flex justify-between rounded-xl bg-[#F5F8FF] py-2 px-3">
          {' '}
          <Rate
            rating={gradeObj?.grade}
            color={{
              filled: '#FFD700',
              unfilled: '#808080',
            }}
            count={5}
            size={'sm'}
            isReadOnly={true}
          />
          <div className="ml-2 font-medium text-[#4E4E4E]">
            {gradeObj?.grade} out of 5
          </div>
          <br />
        </div>
        <div className='bg-[#F9EDCF] rounded-lg flex flex-col  justify-center items-center py-2 px-4'>
          <h2 className="py-2 text-center text-xl font-bold self-start text-[#5E4301]">
            Feedback
          </h2>
          <p className="my-2  text-sm font-medium self-start text-[#9C771B]">
          {props?.feedback}
          </p>
        </div>
        <div className="border-[ #DEDEDE] w-full  mt-4 border-t-2">
          <h2
            className="cursor-pointer text-center mt-5 font-medium text-[#050505] underline"
            onClick={() => setShowScores(!showScores)}
          >
            How do we breakdown scores ?
            {showScores ? (
              <FontAwesomeIcon
                icon={faChevronDown}
                className="mx-2 "
                size="1x"
              />
            ) : (
              <FontAwesomeIcon icon={faChevronUp} className="mx-2" size="1x" />
            )}
          </h2>
          {showScores && (
            <div className='flex flex-col mt-4 justify-center items-center '>
              <div className="my-2 w-1/3 text-center pl-5 flex flex-row rounded-md justify-between items-center text-sm bg-[#B1FCEB] font-semibold ">
                1-10 
                <div className='bg-[#1B997D] w-1/2 text-white py-1 rounded-md'>Poor</div>
              </div>
              <div className="my-2 w-1/3 text-center pl-5  flex flex-row rounded-md justify-between items-center text-sm bg-[#B1FCEB] font-semibold ">
                11-25 
                <div className='bg-[#1B997D] w-1/2 text-white py-1 rounded-md'>Average</div>
              </div>
              <div className="my-2 w-1/3 text-center pl-5  flex flex-row rounded-md justify-between items-center text-sm bg-[#B1FCEB] font-semibold ">
                26-40
                <div className='bg-[#1B997D] w-1/2 text-white py-1 rounded-md'>Good</div>
              </div>
              <div className="my-2 w-1/3 text-center pl-5  flex flex-row rounded-md justify-between items-center text-sm bg-[#B1FCEB] font-semibold ">
                41+ 
                <div className='bg-[#1B997D] w-1/2 text-white py-1 rounded-md'>Exellent</div>
              </div>
             </div>
          )}
        </div>
      </div>
      {props?.type === 'submission' &&
        props?.status !== 'resubmission' &&
        props?.image_link && <TaskCertificate image_link={props?.image_link} user_task={props?.user_task} />}
      {props?.type === 'resubmission' &&
        props?.status === 'resubmission' &&
        props?.image_link && <TaskCertificate image_link={props?.image_link} user_task={props?.user_task}/>}
    </>
  );}
  else{
    return(
      <>
       <div className='flex flex-row w-full border-b-2 py-2 justify-between' onClick={(e)=> setShowGrade(!showGrade)}>
        <div>Grade </div>
        <button className="ml-4 cursor-pointer text-center">
            <FontAwesomeIcon
              icon={showGrade ? faMinus : faPlus}
              className={`${showGrade? 'text-[#F1870A]' : ''}`}
            />
          </button>
      </div>
        { showGrade && (
            <div className="m-4 flex flex-col items-center justify-between rounded-xl p-4 shadow-2xl">
              <h2 className="py-2 text-2xl font-bold text-[#C87902]">
                You scored __
              </h2>
              <div>
                <img src={'https://assets.learntube.ai/files/Content_player/Group_5508.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968484801'} alt="smiley face" srcset="" />
              </div>
              <div className='mt-6 flex flex-row justify-center items-center bg-[#FFF5E0] border-2 border-[#F8D07E] rounded-md px-2 py-1'>
                <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src={'https://assets.learntube.ai/files/PRICING/img6.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658936163623'}
                  transformation={[{
                    "height": "160",
                    "width": "160",
                  }]}
                  className="h-4"
                />
                <small className='text-sm ml-1 text-[#E8AB2A] font-semibold'>{userActivity?.ASK_TASK_REVIEW?.cost}</small>
              </div>
              <div className='mt-4 mb-4 flex flex-row justify-center items-center bg-[#FFF5E0] border-2 border-[#F8D07E] rounded-md px-3 py-1 gradecard-background' >
                <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src={'https://assets.learntube.ai/files/PRICING/img28.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662191682870'}
                  transformation={[{
                    "height": "160",
                    "width": "160",
                  }]}
                  className="h-"
                />
                <small className='text-md ml-2 font-semibold'>Premium Feature</small>
              </div>
              <div className=" flex justify-between rounded-xl bg-[#F5F8FF] py-2 px-3">
                {' '}
                <Rate
                  rating={gradeObj?.grade}
                  color={{
                    filled: '#FFD700',
                    unfilled: '#808080',
                  }}
                  count={5}
                  size={'sm'}
                  isReadOnly={true}
                />
                <div className="ml-2 font-medium text-[#4E4E4E]">
                  ? out of 5
                </div>
                <br />
              </div>
              <div className=' rounded-lg  text-sm font-semibold text-center justify-center items-center py-2 px-4'>
              Please upgrade to receive personalised feedback from a top industry expert, get your project graded & get a project completion certificate!
              </div>
              <div className='mt-4 text-md font-bold text-center'>
              Upgrade to Unlock Your Project Certificate & Increase Chances of Getting Hired By 32%
              </div>
              <img src={props?.user_task?.certificate_image_link} alt="" srcset="certificate image link" className='w-1/2 mt-5 mb-5'></img>
            </div>)
  }
  </>
    )
  }
}
